import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { CustomServiceService } from '../../service/custom-service.service';
import { environment } from 'src/environments/environment';
declare let $: any;
import * as CryptoJS from 'crypto-js';
import { Buffer } from 'buffer';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-content-details',
  templateUrl: './content-details.component.html',
  styleUrls: ['./content-details.component.css']
})
export class ContentDetailsComponent implements OnInit {


  constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute, private route: Router, public encDec: EncryptDecryptService, private httpservice: CustomServiceService, public translate: TranslateService) { }

  content_apiresponse: any;
  PageContent: any = {};
  fetureimage: any = '';
  title: any = '';
  english_content: any;
  VCHMETADESCRIPTI: any = '';
  VCHMETAKEYWORD: any = '';
  VCHMETATITLE: any = '';
  VCHPAGETITLE: any = '';
  contentInEng: any = "";
  contentInHnd: any = "";
  pgTitleEng: any = "";
  pgTitleHnd: any = "";
  contentImg: any = "";
  sessionLangData: any = "en";

  backendUrl = environment.serviceURL;
  pageAlias: any = "";

  language: any =  sessionStorage.getItem('locale');//dynamic
  CURRENT_ZONE_ID: any = environment.ZONE_ID;
  CURRENT_REGION_ID: any = environment.REGION_ID;
  CURRENT_ZONE_CODE: any = environment.ZONE_CODE;
  CURRENT_REGION_CODE: any = environment.REGION_CODE;
  datetime: any = this.httpservice.currentDateTime();
  ngOnInit(): void {
    this.pageAlias = this.routerparam.snapshot.paramMap.get('pageid');//Overview
    this.loadPageAliasDetails();
    setTimeout(()=>{
      var links = document.querySelectorAll('.content-details');
      for (let i = 0; i < links.length; i++) {
        var currentLink = links[i];
        currentLink.addEventListener('click', this.clickHandler);
      }
    },1500);
  }

  ngAfterViewInit(): void {
    //FOR SCROLLING TO TOP WHEN COMPONENT LOADS
    // $('html, body').scrollTop(0);
  }


  clickHandler(e: any) {

    let url = e.target.href;

    var getDomainName = function (domain: any) {
      var parts = domain.split('.').reverse();
      var cnt = parts.length;
      if (cnt >= 3) {
        // see if the second level domain is a common SLD.
        if (parts[1].match(/^(com|edu|gov|net|mil|org|nom|co|name|info|biz)$/i)) {
          return parts[2] + '.' + parts[1] + '.' + parts[0];
        }
      }
      return parts[1] + '.' + parts[0];
    };

    var isExternalUrl = function (url: any) {
      var curLocationUrl = getDomainName(location.href.replace("http://", "").replace("https://", "").replace("//", "").split("/")[0].toLowerCase());
      var destinationUrl = getDomainName(url.replace("http://", "").replace("https://", "").replace("//", "").split("/")[0].toLowerCase());


      return !(curLocationUrl === destinationUrl)
    };


    if (isExternalUrl(url)) {
      e.preventDefault();
      Swal.fire({
        title: 'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
        showDenyButton: true,
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.isConfirmed) {
          window.open(e.target.href, '_blank')
        }
      })
    }



  }



  loadPageAliasDetails() {
    let params = [{
      "secSlNo": 1,
      "offSet": 0,
      "noOfRecords": 0,
      "condition": [
        { "columnName": "VCHPAGEALIAS", "operator": "=", "value": this.pageAlias, "joinoperator": "and" },
        { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
        { "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" }
      ],
      "viewParameters": ""
    }];
    this.fciwebservice.getAll(params, "ContentPage").subscribe((response: any) => {
      let apirespons = response;
      let respData = apirespons.RESPONSE_DATA;
      let respToken = apirespons.RESPONSE_TOKEN;
      let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
      if (respToken == verifyToken) {
        let response: any = Buffer.from(respData, 'base64');
        response = JSON.parse(response);
        if (response.status == 200) {
          if (response.result.sec_1.length > 0) {


            let allResponseData: any = response.result.sec_1[0];
            this.contentInEng = allResponseData["content"];
            this.contentInHnd = allResponseData["contentInHindi"];
            this.pgTitleHnd = allResponseData["pageTitleInHindi"];
            this.pgTitleEng = allResponseData["pageTitleInEnglish"];
            this.contentImg = allResponseData["featureImage"];

            let xxx:any = document.getElementById('conEnglish');
            xxx.innerHTML = this.language=='English'? this.encDec.decodeHtml(this.contentInEng):this.encDec.decodeHtml(this.contentInHnd);

            document.title = allResponseData.metaTitle;
            let TITLE = document.createElement('meta');
            TITLE.name = "TITLE";
            TITLE.content = allResponseData.metaTitle;
            document.getElementsByTagName('head')[0].appendChild(TITLE);

            let KEYWORDS = document.createElement('meta');
            KEYWORDS.name = "KEYWORDS";
            KEYWORDS.content = allResponseData.metaKeyword;
            document.getElementsByTagName('head')[0].appendChild(KEYWORDS);

            let DESCRIPTION = document.createElement('meta');
            DESCRIPTION.name = "DESCRIPTION";
            DESCRIPTION.content = allResponseData.metaDescription;
            document.getElementsByTagName('head')[0].appendChild(DESCRIPTION);
          }
        }
      }

    })
  }









  htmldecode(str: any) {
    return this.encDec.decodeHtml(str);
  }


}
